import { Access } from 'modules/core/hooks/useCurrentSession'

// FIXME: consider moving this to the backend
export const accessLegalName = (access: Access) => {
  return [access.firstName, access.lastName].filter(Boolean).join(' ')
}
